/**
 * 分析结果对象
 * @typedef {Object} AnalysisResult
 * @property {Object} selectedPoint - { lat, lng }
 * @property {Object|null} subzone - Subzone 信息
 * @property {Object|null} planningArea - Planning Area 信息
 * @property {Object|null} fengShuiProps - 风水属性
 * @property {Object} nearestNode - { node, distance }
 * @property {Array} nodesInRange - 影响范围内节点
 * @property {Object|null} nearestVein - { vein, distance }
 */

class AnalysisResultBuilder {
  constructor(lat, lng) {
    this.result = {
      selectedPoint: { lat, lng },
      subzone: null,
      planningArea: null,
      fengShuiProps: null,
      nearestNode: null,
      nodesInRange: [],
      nearestVein: null
    };
  }

  setRegionMatch(subzone, planningArea) {
    this.result.subzone = subzone;
    this.result.planningArea = planningArea;
    return this;
  }

  setFengShuiProps(props) {
    this.result.fengShuiProps = props;
    return this;
  }

  setNearestNode(nearestNode) {
    this.result.nearestNode = nearestNode;
    return this;
  }

  setNodesInRange(nodes) {
    this.result.nodesInRange = nodes;
    return this;
  }

  setNearestVein(vein) {
    this.result.nearestVein = vein;
    return this;
  }

  build() {
    return Object.freeze({ ...this.result });
  }
}

export { AnalysisResultBuilder };
